export const componentRef = 'otp-authenticator';
